import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@biomejs+biome@1.9.4_@parcel+watcher@2.5.1_@types+node@22.13.4_better-sqlit_d9bb4c2d7e028c16a15164ef67484f60/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@biomejs+biome@1.9.4_@parcel+watcher@2.5.1_@types+node@22.13.4_better-sqlit_d9bb4c2d7e028c16a15164ef67484f60/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}